import { z } from "zod";
/** Operator-owned Tax Operations authenticators. Separate from Tool passkeys. */
export const MAX_OPERATOR_PASSKEYS = 20;
/**
 * Single-use authentication/registration challenge lifetime. Shared by the
 * API (which enforces it on `/v1/auth/passkeys/verify` and
 * `/v1/auth/passkeys/register/verify`) and the web client (which uses it to
 * refresh a conditional-mediation autofill request before the challenge it
 * is holding can expire).
 */
export const PASSKEY_CHALLENGE_TTL_SECONDS = 300;
export const passkeyCredentialSchema = z
    .object({
    id: z.string().uuid(),
    label: z.string().min(1).max(120),
    transports: z.array(z.string().min(1).max(32)).max(8),
    createdAt: z.string().datetime(),
    lastUsedAt: z.string().datetime().nullable(),
})
    .strict();
export const passkeyCredentialListSchema = z
    .object({
    items: z.array(passkeyCredentialSchema),
})
    .strict();
export const passkeySessionSchema = z
    .object({
    idToken: z.string().min(1),
    refreshToken: z.string().min(1),
})
    .strict();
//# sourceMappingURL=passkeys.js.map